import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import ErpExportTransactionTableFilter from "../Filters/ErpExportTransactionTableFilter";
import moment from "moment";
import { odata } from "../Filters/Helper";
import ErpVirmanMatchedTransaction from "./ErpVirmanMatchedTransaction";
import config from "../../util/ApiforContext";
import ErpReportSummary, { SummaryDataList } from "./ErpReportSummary.js";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  notification,
  Select,
  Tooltip,
  Popconfirm,
  Tabs,
  Input,
  Modal,
  Typography,
  Form,
  message,
  Switch,
} from "antd";
import {
  BarsOutlined,
  SendOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  PlusOutlined,
  DeleteOutlined,
  EditOutlined,
  FileExcelOutlined,
  SwapOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import FirmTransactionMatchForm from "../Forms/FirmTransactionMatchForm";
import TextArea from "antd/lib/input/TextArea";
import { CurrencyHelper, FormatMoney } from "../../util/CurrencyHelper";
import { useMediaQuery } from "react-responsive";
import MultipleAccountTransactionRuleList from "../Rule/MultipleAccountTransactionRuleList";
import ErpLogoDoubleCheckTransaction from "./ErpLogoDoubleCheckTransaction";
import { lowerCase } from "lodash";


const EditableCell = ({
  key,
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode =
    inputType === "number" ? (
      <Input
        type="number"
        onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
      />
    ) : null;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Lütfen ${title} giriniz!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
const ErpExportTransaction = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 100,
    current: 1,
    activeTab: "0",
    filter: "",
  });

  const [summaryData, setSummaryData] = useState({
    totals: [{ amount: 0, count: 0, currency: "" }],
    successes: [{ amount: 0, count: 0, currency: "" }],
    errors: [{ amount: 0, count: 0, currency: "" }],
    transferables: [{ amount: 0, count: 0, currency: "" }],
  });
  const [loadingSummary, setLoadingSummary] = useState(false);
  const [filterSummary, setFilterSummary] = useState(true);

  const [options, setOptions] = useState({ pageTitle: "ERP AKTARIM" });
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [tenantIdList, setTenantIdList] = useState([
    "381d62ec-9eab-ed11-a2d3-005056b667e2",
  ]);
  const [firmClass, setFirmClass] = useState({
    data: [],
    loading: true,
  });
  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: true,
  });
  const [firm, setFirm] = useState([]);
  const [columnSettings, setColumnSettings] = useState();
  const [transactionDateControl, setTransactionDateControl] = useState();
  const [confirmErpTitle, setConfirmErpTitle] = useState();
  const [cardType, setCardType] = useState();
  const [erpProgramId, setErpProgramId] = useState();
  const [onlyFullOnes, setOnlyFullOnes] = useState();
  const [operationType, setOperationType] = useState();
  const [operationType2, setOperationType2] = useState();
  const [isDivisionAndDeparment, setIsDivisionAndDeparment] = useState();
  const [selectType, setSelectType] = useState(true);
  const [isGo3SendExchangeRate, setIsGo3SendExchangeRate] = useState(false);
  const [transactionProjectTypes, setTransactionProjectTypes] = useState([]);

  const [tabKeyValue, setTabKeyValue] = useState();
  const [firmMatchModal, setFirmMatchModal] = useState({
    isUpdate: false,
    isVisible: false,
  });
  const [firmMatchFormData, setFirmMatchFormData] = useState();
  const [chequeNumbers, setChequeNumbers] = useState([]);

  const [specialActionCodes, setSpecialActionCodes] = useState({
    data: [],
    loading: false,
  });

  const [cosCenters, setCosCenter] = useState({ data: [], loading: false });
  const [referenceCodes, setReferenceCode] = useState({
    data: [],
    loading: false,
  });
  const [editingKey, setEditingKey] = useState("");
  const isEditing = (record) => record.id === editingKey;
  const [form] = Form.useForm();
  const [duplicateTake, setDuplicateTake] = useState(100);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [erpType, setErpType] = useState();
  const isBigScreen = useMediaQuery({
    query: "(min-device-width: 1824px)",
  });

  const [virmanTransactions, setVirmanTransactions] = useState([]);
  const [virmanPopConfirmVisible, setVirmanPopConfirmVisible] = useState(false);
  const [isCheckedColumnVisible, setIsCheckedColumnVisible] = useState(false);
  const [matchedVirmanTransactions, setMatchedVirmanTransactions] = useState(
    []
  );
  const [
    visibleVirmanMatchedTransactions,
    setVisibleVirmanMatchedTransactions,
  ] = useState(false);

  const [selectedVirmanTransactions, setSelectedVirmanTransactions] = useState(
    []
  );
  const [multipleRuleAddModalVisible, setMultipleRuleAddModalVisible] =
    useState(false);

  const [multipleRuleAddData, setMultipleRuleAddData] = useState([]);
  const [
    visibleLogoCheckTransactionModal,
    setVisibleLogoCheckTransactionModal,
  ] = useState(false);

  const [logoCheckData, setLogoCheckData] = useState([]);
  const [allProjects, setAllProjects] = useState([]);

  const logoTransactionTypes = [
    { code: "1", name: "Nakit" },
    { code: "2", name: "Havale" },
    { code: "3", name: "EFT" },
    { code: "4", name: "Banka Masrafları" },
    { code: "5", name: "Stopaj Kesintisi" },
    { code: "6", name: "Damga Vergisi" },
    { code: "7", name: "Stopaj Üzerinden Fon Kesintisi" },
    { code: "8", name: "Çek Tahsilatı" },
    { code: "9", name: "Repo Açılış/Geri Dönüş" },
    { code: "10", name: "Vadeli Hesap Açılışı/Geri Dönüş" },
    { code: "11", name: "Kredi Açılış/Kapanış" },
    { code: "12", name: "Firma Hesapları Arası Virman" },
    { code: "13", name: "Senet Tahsilatı" },
    { code: "14", name: "İhracat Tahsilatı" },
    { code: "15", name: "İthalat Ödemesi" },
    { code: "16", name: "Döviz Alış/Satışı" },
    { code: "17", name: "Faiz Geliri/Gideri" },
    { code: "18", name: "Karşılıksız Senet Protesto Masrafı" },
    { code: "19", name: "Doğrudan Borçlanma" },
    { code: "20", name: "KKDF Ödemesi" },
    { code: "21", name: "Repo Faiz Geliri" },
    { code: "22", name: "Bono Alış/Satış" },
    { code: "23", name: "Yatırım Fonu Alış/Satış" },
    { code: "24", name: "İthalat Masrafı" },
    { code: "25", name: "Teminat Mektubu Komisyonu" },
    { code: "26", name: "Fatura Ödemesi" },
    { code: "27", name: "Kurumlar Fatura" },
    { code: "28", name: "BSMV" },
    { code: "29", name: "Akreditif Ödemesi" },
    { code: "30", name: "Akreditif Komisyonu" },
    { code: "31", name: "Akreditif Masrafı" },
    { code: "32", name: "Erken/Geç Faiz Ödemesi" },
    { code: "999", name: "Diğer İşlemler" },
  ];

  const cardTypeSelect = [
    { key: "1", value: "Ticari Hesap" },
    { key: "2", value: "Kredi Hesabı" },
    { key: "3", value: "Dövizli Ticari Hesap" },
    { key: "4", value: "Dövizli Kredi Hesabı" },
    { key: "5", value: "Kredi Kartı Hesabı" },
    { key: "6", value: "Dövizli Kredi Kartı Hesabı" },
  ];

  const [chaResponsbilityCodes, setChaResponsbilityCodes] = useState({
    data: [],
    loading: false,
  });
  const [projects, setProjects] = useState({
    data: [],
    loading: false,
  });
  const [specialCodes, setSpecialCodes] = useState({
    data: [],
    loading: false,
  });

  const [defaultChaResponsbilityCode, setDefaultChaResponsbilityCode] =
    useState(null);
  const [defaultChaResponsbilityCodeId, setDefaultChaResponsbilityCodeId] =
    useState(null);
  const [defaultSpecialCode, setDefaultSpecialCode] = useState(null);
  const [defaultSpecialCodeId, setDefaultSpecialCodeId] = useState(null);
  const [defaultProjectCode, setDefaultProjectCode] = useState(null);
  const [defaultProjectCodeId, setDefaultProjectCodeId] = useState(null);
  const [defaultCosCenter, setDefaultCosCenter] = useState({});
  const [groupNumbers, setGroupNumbers] = useState({
    data: [],
    loading: true,
  });

  const [allowMarkAsTransfered, setAllowMarkAsTransfered] = useState(false);

  const [showAccountName, setShowAccountName] = useState(false);

  const getResponsibilityCenter = () => {
    RequestHandler.get(
      `/TransactionProjectType?$count=true&$filter=(ProjectType eq 3 or ProjectType eq 9 or ProjectType eq 0 or ProjectType eq 2) and IsActive eq true and ishhDefault eq true`
    ).then((response) => {
      const defaultChaResponsbilityCode = response.value.filter(
        (x) => x.projectType == 3 && x.ishhDefault
      );
      if (defaultChaResponsbilityCode.length > 0) {
        setDefaultChaResponsbilityCode(
          defaultChaResponsbilityCode[0].projectCode
        );
        setDefaultChaResponsbilityCodeId(defaultChaResponsbilityCode[0].id);

        setChaResponsbilityCodes({
          data: defaultChaResponsbilityCode,
          loading: false,
        });
      }
      const defaultSpecialCode = response.value.filter(
        (x) => x.projectType == 9 && x.ishhDefault
      );
      if (defaultSpecialCode.length > 0) {
        setDefaultSpecialCode(defaultSpecialCode[0].projectCode);
        setDefaultSpecialCodeId(defaultSpecialCode[0].id);
        setSpecialCodes({ data: defaultSpecialCode, loading: false });
      }

      const defaultProjectCode = response.value.filter(
        (x) => x.projectType == 0 && x.ishhDefault
      );
      if (defaultProjectCode.length > 0) {
        setDefaultProjectCode(defaultProjectCode[0].projectCode);
        setDefaultProjectCodeId(defaultProjectCode[0].id);

        setProjects({ data: defaultProjectCode, loading: false });
      }

      const defaultCosCenter = response.value.filter(
        (x) => x.projectType == 2 && x.ishhDefault
      );

      if (defaultCosCenter.length > 0) {
        setDefaultCosCenter(defaultCosCenter[0]);
      }
    });
  };

  const operationTypes = [
    { id: "0", name: "Belirtilmemiş" },
    { id: "1", name: "Nakit" },
    { id: "4", name: "Banka masrafı" },
    { id: "5", name: "Stopaj kesintisi" },
    { id: "6", name: "Damga vergisi" },
    { id: "7", name: "Stopaj üzerinden fon kesintisi" },
    { id: "8", name: "Çek tahsilatı" },
    { id: "9", name: "Repo Açılış/geri dönüş" },
    { id: "10", name: "Vadeli hesap açılışı/ geri dönüş" },
    { id: "11", name: "Kredi açılış/kapanış" },
    { id: "12", name: "Firma hesaplar arası virman" },
    { id: "13", name: "Senet tahsilatı" },
    { id: "14", name: "İhracat tahsilatı" },
    { id: "15", name: "İthalat ödemesi" },
    { id: "16", name: "Döviz alış/satışı" },
    { id: "17", name: "Faiz gelir/gideri" },
    { id: "18", name: "Karşılıksız senet protesto masrafı" },
    { id: "19", name: "Doğrudan borçlandırma" },
    { id: "20", name: "KKDF Ödemesi" },
    { id: "21", name: "Repo faiz geliri" },
    { id: "22", name: "Bono alış/satışı" },
    { id: "23", name: "Yatırım fonu alış/satışı" },
    { id: "24", name: "İthalat masrafı" },
    { id: "25", name: "Teminat mektubu komisyonu" },
    { id: "26", name: "Fatura ödemesi" },
    { id: "27", name: "Kurumlar fatura" },
    { id: "28", name: "BSMV" },
    { id: "29", name: "Akreditif ödemesi" },
    { id: "30", name: "Akreditif komisyonu" },
    { id: "31", name: "Akreditif masrafı" },
    { id: "999", name: "Diğer işlemler" },
  ];

  useEffect(() => {
    const pageOptions = {
      1: {
        pageTitle: "ERP AKTARIM - GELEN",
      },
      2: {
        pageTitle: "ERP AKTARIM - GİDEN",
      },
    };
    if (pageOptions[props.transactionProcessType]) {
      setOptions(pageOptions[props.transactionProcessType]);
    }
  }, []);

  useEffect(() => {
    getColumnSettings();
    getResponsibilityCenter();
    getTenantUserParameter();
    getGroupNumbers();

    RequestHandler.get(
      `/TransactionProjectType?$filter=(ProjectType eq 5 or ProjectType eq 6) and isActive eq true`
    ).then((response) => {
      setTransactionProjectTypes(response.value);
    });

    RequestHandler.get(
      `/TransactionProjectType?$select=id,projectCode,name,projectType&$filter=ProjectType eq 2 and Name ne 'Diğer' and isActive eq true`
    ).then((res) => {
      setCosCenter({ data: res.value, loading: false });
    });
  }, []);
  useEffect(() => {
    if (columnSettings) {
      getTableData();
      getCurrencies();
    }
  }, [tableDataQueryOptions, columnSettings]);

  const getTenantUserParameter = () => {
    RequestHandler.get(`/TenantUserParameter/GetDigitParameter`).then(
      (response) => {
        if (response.success) {
          setShowAccountName(response.data.showAccountNameInErpTable);
          setAllowMarkAsTransfered(
            response.data.markAsErpTransferredTransaction
          );
        }
      }
    );
  };

  const getCurrencies = () => {
    setCurrencySelect({
      data: [],
      loading: true,
    });
    RequestHandler.get(`/Currency?$select=id,code`).then((response) => {
      setCurrencySelect({
        data: response.value,
        loading: false,
      });
    });
  };

  const onClickExportExcel = () => {
    const hideMessage = message.loading("Excel indiriliyor...", 0);
    setSelectedRowKeys([]);

    const { filter, activeTab } = tableDataQueryOptions;

    let conditions = ["isManualTransaction Eq false"];
    let query = "";

    if (props.transactionProcessType) {
      conditions.push(
        `TransactionProcessTypeValue Eq ${props.transactionProcessType}`
      );
    }

    if (activeTab !== "-1") {
      conditions.push(`erpTransferStatusId Eq ${activeTab}`);
    }

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = "&$filter=" + conditions.join(" and ");
    }
    RequestHandler.post(
      `/ErpAccountTransaction/ExportExcel`,
      {
        query: query,
      },
      false
    ).then((response) => {
      hideMessage();
      if (response) {
        window.open(
          `${
            config.apiUrl
          }/ErpAccountTransaction/DownloadExcel?fileName=${response}&t=${RequestHandler.getToken()}`
        );
      }
    });
  };

  const fillFirmClassforGo3 = (data, temp) => {
    data.forEach((x) => {
      x.firmClassId =
        x?.firmClassName === "Cari"
          ? temp
            ? temp.id
            : x?.firmClassId
          : x?.firmClassId;
      x.firmClassName =
        x?.firmClassName === "Cari"
          ? temp
            ? temp.name
            : x?.firmClassName
          : x?.firmClassName;
    });
  };

  const setSummaryDataList = (response) => {
    setSummaryData(SummaryDataList(response));
    setLoadingSummary(false);
  };
  const getSummaryData = () => {
    // setLoadingSummary(true);
    // const { filter } = tableDataQueryOptions;
    // let summaryQuery = "",
    //   summaryFilter = "";
    // let conditions = ["isManualTransaction Eq false"];
    // if (props.transactionProcessType)
    //   conditions.push(
    //     `TransactionProcessTypeValue Eq ${props.transactionProcessType}`
    //   );
    // if (filter) conditions.push(filter);
    // else {
    //   const today = new Date();
    //   today.setMonth(today.getMonth() - 6);
    //   summaryFilter = ` and transactionDate ge ${
    //     today.toISOString().split("T")[0]
    //   }`;
    // }
    // if (conditions.length !== 0) summaryQuery = conditions.join(" and ");
    // RequestHandler.get(
    //   `/ErpAccountTransaction/GetSummary?$select=id,amount,currencyCode,erpTransferStatusId&$filter=${summaryQuery}${summaryFilter}`
    // ).then((response) => {
    //   setSummaryData(response);
    //   setLoadingSummary(false);
    // });
  };

  const getTableData = (isRefresh) => {
    setSelectedRowKeys([]);

    //isRefresh eşleştirme sonucu dropdownların state i update olması için
    setTableData(
      isRefresh
        ? {
            data: [],
            total: 0,
            loading: true,
          }
        : { ...tableData, loading: true }
    );
    const { skip, take, filter, activeTab } = tableDataQueryOptions;

    let conditions = ["isManualTransaction Eq false"];
    let query = "";

    if (props.transactionProcessType) {
      conditions.push(
        `TransactionProcessTypeValue Eq ${props.transactionProcessType}`
      );
    }

    if (activeTab !== "-1") {
      conditions.push(`erpTransferStatusId Eq ${activeTab}`);
    }

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = conditions.join(" and ");
    }
    RequestHandler.get(
      `/ErpAccountTransaction?$count=true&$filter=${query}&$skip=${skip}&$top=${take}`
    )
      .then((response) => {
        if (isExportAvailable && response.value) {
          response.value.forEach((x) => {
            if (tenantIdList.includes(localStorage.getItem("tenantId"))) {
              if (
                x.description.split(" ")[2] === "KUR" ||
                (x.description.split(" ")[2] === "KUR" && tabKeyValue === "1")
              ) {
                x.currency = x.description.split(" ")[5]?.substring(0, 3);
                x.currencyExChangeRate = parseFloat(
                  x.description.split(" ")[1].replace(",", ".")
                );
              }
              if (tabKeyValue === "1") {
                x.projectCode =
                  x.description.startsWith("GX-") ||
                  x.description.startsWith("KMARGE-")
                    ? x.description.split("-")[1].substring(0, 5)
                    : x.projectCode;
              }
            }

            if (!x.chaResponsibilityCode) {
              x.chaResponsibilityCode =
                columnSettings.centerOfResponsibilityCode;
            }
          });
        }
        return response;
      })
      .then((response) => {
        if (columnSettings.erpProgramId == 13) {
          var _firmClass = firmClass.data;
          if (_firmClass == undefined || _firmClass.length == 0) {
            RequestHandler.get(
              `/FirmClass?$filter=isErpType Eq true&${odata.orderBy("name")}`
            ).then((responseFirm) => {
              if (props.transactionProcessType == 1) {
                var temp = responseFirm.value.filter(
                  (i) => i.erpValue == "3"
                )[0];
                setErpType({
                  id: temp.id,
                  name: temp.name,
                });
                fillFirmClassforGo3(response.value, temp);
              } else {
                var temp = responseFirm.value.filter(
                  (i) => i.erpValue == "4"
                )[0];
                setErpType({
                  id: temp.id,
                  name: temp.name,
                });
                fillFirmClassforGo3(response.value, temp);
              }
              setTableData({
                data: response.value,
                total: response["@odata.count"],
                loading: false,
              });
              setTotalDataCount(response["@odata.count"]);
            });
          } else {
            fillFirmClassforGo3(response.value, erpType);
            setTableData({
              data: response.value,
              total: response["@odata.count"],
              loading: false,
            });
            setTotalDataCount(response["@odata.count"]);
          }
        } else {
          setTableData({
            data: response.value,
            total: response["@odata.count"],
            loading: false,
          });
          setTotalDataCount(response["@odata.count"]);
        }
      });
  };
  const getFirmClasses = (value, erpProgramId) => {
    RequestHandler.get(
      `/FirmClass?$filter=isErpType Eq true&${odata.orderBy("name")}`
    ).then((response) => {
      if (erpProgramId == 13) {
        if (props.transactionProcessType == 1) {
          var temp = response.value.filter((i) => i.erpValue == "3")[0];
          setErpType({
            id: temp.id,
            name: temp.name,
          });
        } else {
          var temp = response.value.filter((i) => i.erpValue == "4")[0];
          setErpType({
            id: temp.id,
            name: temp.name,
          });
        }
      }

      if (props.transactionProcessType === 2 && !value) {
        const data = response.value.filter(
          (item) => item.firmClassIsBankType !== true
        );
        setFirmClass({
          data: data,
          loading: false,
        });
      } else {
        setFirmClass({
          data: response.value,
          loading: false,
        });
      }
    });
  };
  const getColumnSettings = () => {
    let isHasvirman = false;
    let erpProgramId = 0;
    RequestHandler.get("/TenantErpProgram/GetByTenant").then((response) => {
      if (response) {
        setColumnSettings(response);
        setTransactionDateControl(response.transactionDateControl);
        setCardType(response.isHasCardType);
        setErpProgramId(response.erpProgramId);
        setOnlyFullOnes(response.isOnlyFullOnes);
        setOperationType(response.isOperationType);
        setOperationType2(response.isOperationType2);
        setIsGo3SendExchangeRate(response.isGo3SendExchangeRate);
        setIsDivisionAndDeparment(response.isDivisionAndDeparment);
        isHasvirman = response.isHasVirmanTransaction;
        erpProgramId = response.erpProgramId;
        if (response.isDynamicDescriptionToMikro) {
          RequestHandler.get(`/TransactionProjectType/GetAllProjects`).then(
            (res) => {
              setAllProjects(res);
            }
          );
        }
      } else {
        //erp tanımlı değilse sadece table loaderı kaldırdık
        setTableData({ ...tableData, loading: false });
      }
      getFirmClasses(isHasvirman, erpProgramId);
    });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });

    if (columnSettings?.isHasDuplicateTransaction) {
      setDuplicateTake(p.pageSize);
    }
  };

  const onClearTableFilter = () => {
    setFilterSummary(true);
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setFilterSummary(true);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
      };
    });
  };

  const onTableSelect = (record, selected, selectedRows) => {
    setSelectedRowKeys(selectedRows.map((row) => row.id));
    let rowKeys = selectedRows.map((row) => row.id);
    setSelectedRowKeys(rowKeys);
    if (rowKeys.length == 0) getSummaryData();
    else
      setSummaryDataList(
        tableData.data.filter((row) => rowKeys.includes(row.id))
      );
  };

  const onTableSelectAll = (selectedKeys, selectedRows, changeRows) => {
    let rowKeys = selectedRows.map((row) => row.id);
    if (rowKeys.length == 0) getSummaryData();
    else
      setSummaryDataList(
        tableData.data.filter((row) => rowKeys.includes(row.id))
      );

    if (selectType) setSelectedRowKeys(selectedRows.map((row) => row.id));
    else {
      const selectedKeys = selectedRows
        .filter((row) => row.firmId != null && row.firmClassId != null)
        .map((row) => row.id);
      setSelectedRowKeys(selectedRowKeys.length == 0 ? selectedKeys : []);
    }
  };

  const onConfirmExport = () => {
    let isSuccess = true;
    const filteredData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );
    const selectedRowsData =
      columnSettings?.isHasCenterOfResponsibility &&
      columnSettings?.isUseSelectBoxForResponsibilityCenter
        ? filteredData.map((row) => {
            let centerOfResponsibilityCode = {
              projectCode: row.chaResponsibilityCode,
              id: row.chaResponsibilityCodeId,
            };

            if (chaResponsbilityCodes.data.length > 0) {
              centerOfResponsibilityCode = row.chaResponsibilityCode
                ? chaResponsbilityCodes.data.find(
                    (item) => item.projectCode === row.chaResponsibilityCode
                  )
                : chaResponsbilityCodes.data.find(
                    (item) => item.id === row.centerOfResponsibilityCodeId
                  );
            }

            return {
              ...row,
              centerOfResponsibilityCodeId:
                centerOfResponsibilityCode?.id || null,
              chaResponsibilityCode:
                centerOfResponsibilityCode?.projectCode || null,
            };
          })
        : filteredData;
    const defaultSpecialCodeValue = defaultSpecialCode
      ? specialCodes.data.find(
          (item) => item.projectCode === defaultSpecialCode
        )?.id
      : null;
    selectedRowsData.forEach((row) => {
      if (row.chaResponsibilityCode == null && chaResponsbilityCodes) {
        row.chaResponsibilityCode = defaultChaResponsbilityCode;
        row.centerOfResponsibilityCodeId = chaResponsbilityCodes.data.find(
          (item) => item.projectCode === defaultChaResponsbilityCode
        )?.id;
      }
      if (row.specialCodeId == null) {
        row.specialCodeId = defaultSpecialCodeValue;
      }
      if (row.projectCode == null) {
        row.projectCode = defaultProjectCode;
        row.transactionProjectTypeId = projects.data.find(
          (item) => item.projectCode === defaultProjectCode
        )?.id;
      }

      if (row.cosCenterCode == null) {
        row.cosCenterCode = defaultCosCenter.projectCode;
      }
    });

    // tenantAccountErpCode valuesu olmayan bir tenant account hareketi seçili ise
    if (selectedRowsData.some((row) => !row.tenantAccountErpCode)) {
      notification.error({
        message:
          "Seçili hesap hareketleri içerisinde 'Erp Kodu' olmayan Hesaba ait kayıtlar var.",
        duration: 3,
      });
      isSuccess = false;
    }
    // erp valuesu olan bir firmClass ve cari seçili değilse
    if (
      !selectedRowsData.every(
        (row) =>
          firmClass.data.some(
            (firmClassHasErpValue) =>
              firmClassHasErpValue.id === row.firmClassId
          ) &&
          row.firmId &&
          row.firmId !== "00000000-0000-0000-0000-000000000000"
      )
    ) {
      notification.error({
        message:
          "Seçili hesap hareketleri içerisinde 'Tip' veya 'Cari' seçilmemiş kayıtlar var.",
        duration: 3,
      });
      isSuccess = false;
    }

    // firmBranchNumber valuesu olmayan bir firm seçili ise
    if (selectedRowsData.some((row) => !row.firmBranchNumber)) {
      notification.error({
        message:
          "Seçili hesap hareketleri içerisinde 'Cari Kodu' olmayan Cari kayıtları var.",
        duration: 3,
      });
      isSuccess = false;
    }

    if (
      columnSettings?.isHasChequeNumber &&
      selectedRowsData.some(
        (row) => !row.chequeNumber && row.firmClassName == "Çek"
      )
    ) {
      notification.error({
        message:
          "Seçili hesap hareketleri içerisinde Çek Numarası olmayan Cari kayıtları var.",
        duration: 3,
      });
      isSuccess = false;
    }

    if (
      (isSuccess && props.transactionProcessType === 1) ||
      (columnSettings.isHasVirmanTransaction &&
        props.transactionProcessType === 2 &&
        isSuccess)
    ) {
      const possibleVirmanData = selectedRowsData.filter(
        (item) =>
          item.firmClassIsBankType === true && !item.isDuplicateTransaction
      );

      if (possibleVirmanData.length > 0)
        RequestHandler.post(
          "/ErpAccountTransaction/CheckVirmanTransaction",
          possibleVirmanData,
          false
        ).then((response) => {
          if (response.length > 0) {
            const virmanData = response.filter((item) => item.isVirman || item.isForeignExchangeTransaction);
            if (virmanData.length > 0) {
              const matchedVirmanTransactions = tableData.data.filter((item) =>
                virmanData.some((element) => element.id === item.id)
              );
              setMatchedVirmanTransactions(virmanData);
              setVirmanTransactions(matchedVirmanTransactions);
              setVisibleVirmanMatchedTransactions(true);
              return;
            } else {
              RequestHandler.post(
                "/ErpAccountTransaction",
                selectedRowsData
              ).then((response) => {
                if (response.success) {
                  getTableData();
                } else {
                  isSuccess = false;
                }
              });
            }
          } else {
            RequestHandler.post(
              "/ErpAccountTransaction",
              selectedRowsData
            ).then((response) => {
              if (response.success) {
                getTableData();
              } else {
                isSuccess = false;
              }
            });
          }
        });
      else {
        RequestHandler.post("/ErpAccountTransaction", selectedRowsData).then(
          (response) => {
            if (response.success) {
              getTableData();
            } else {
              isSuccess = false;
            }
          }
        );
      }
    } else {
      if (isSuccess) {
        RequestHandler.post("/ErpAccountTransaction", selectedRowsData).then(
          (response) => {
            if (response.success) {
              getTableData();
            } else {
              isSuccess = false;
            }
          }
        );
      }
    }

    if (columnSettings.useMultipleRuleAddOnErp && isSuccess) {
      const sendDataForRule = selectedRowsData.filter(
        (x) => x.accountTransactionRuleId === null
      );

      if (sendDataForRule.length > 0) {
        openMultipleRuleAddModal(sendDataForRule);
      }
    }
    setFilterSummary(true);
  };

  const TransactionDateControl = () => {
    if (transactionDateControl > 0) {
      const selectedRowsData = tableData.data.filter((row) =>
        selectedRowKeys.includes(row.id)
      );
      const today = new Date();
      today.setDate(today.getDate() - transactionDateControl);
      const control = selectedRowsData.some(
        (i) => new Date(i.transactionDate) < today
      );
      control
        ? setConfirmErpTitle(
            "Geçmişte kalan bir hareketi aktarmak üzeresiniz yine de aktarmak istiyor musunuz? "
          )
        : setConfirmErpTitle("Aktarmak istiyor musunuz?");
    } else setConfirmErpTitle("Aktarmak istiyor musunuz?");
  };

  const openMultipleRuleAddModal = (data) => {
    RequestHandler.get(`/AccountTransactionRule?$count=true`).then(
      (response) => {
        const multipleRuleAddDataJson = data.map((item, index) => ({
          id: item.id,
          key: item.description,
          erpCode: item.firmBranchNumber,
          firmName: item.firmName,
          processType: item.firmClassName,
          firmClassName: item.firmClassName,
          referenceCode: item.referenceCode,
          projectCode: item.projectCode ?? null,
          firmId: item.firmId,
          transactionProjectTypeId: item.transactionProjectTypeId,
          tenantAccountId: item.tenantAccountId,
          replaceKey: item.erpDescription,
          name: `OTM${response["@odata.count"] + index + 1}`,
        }));
        setMultipleRuleAddData(multipleRuleAddDataJson);
        setMultipleRuleAddModalVisible(true);
      }
    );
  };

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      RequestHandler.get(
        `/Firm?$select=id,name,firmBranchNumber,firmClassId,firmClassName,vknCount,currencyCount,firmBalances,divisionId,deparmentId,currencyType,firmClassIsBankType&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains(
          "firmBranchNumber",
          value
        )}) and isActive eq true`
      ).then((res) => {
        if (res.value) {
          setFirm(res.value);
        }
      });
    } else {
      setFirm([]);
    }
  };

  const getFirmByClassName = (firmClassName) => {
    if (firmClassName) {
      RequestHandler.get(
        `/Firm?$select=id,name,firmBranchNumber,firmClassId,firmClassName,vknCount,firmClassExpireDate,currencyCount,firmClassIsBankType&$filter=${odata.contains(
          "firmClassName",
          firmClassName
        )} and ${odata.dateCompare(
          "firmClassExpireDate",
          "gt",
          moment().add(-3, "days")
        )}`
      ).then((res) => {
        if (res.value) {
          setFirm(res.value);
        }
      });
    }
  };

  const onProjectSearch = (value) => {
    if (value.length >= 2) {
      RequestHandler.get(
        `/TransactionProjectType?$select=id,projectCode,name,projectType, ishhdefault&$filter=((${odata.contains(
          "name",
          value
        )} or ${odata.contains(
          "projectCode",
          value
        )}) or ishhdefault eq true)  and ProjectType eq 0 and Name ne 'Diğer'&$orderby=ishhdefault desc`
      ).then((res) => {
        if (res.value) {
          setProjects({ data: res.value, loading: false });
        } else {
          setProjects({ data: [], loading: false });
        }
      });
    }
  };

  const onChaCodeSearch = (value) => {
    if (value.length >= 2) {
      RequestHandler.get(
        `/TransactionProjectType?$select=id,projectCode,name,projectType&$filter=((${odata.contains(
          "name",
          value
        )} or ${odata.contains(
          "projectCode",
          value
        )}) or ishhDefault eq true)  and ProjectType eq 3 and Name ne 'Diğer'&$orderby=ishhdefault desc`
      ).then((res) => {
        if (res.value) {
          setChaResponsbilityCodes({ data: res.value, loading: false });
        } else {
          setChaResponsbilityCodes({ data: [], loading: false });
        }
      });
    }
  };

  const onSpecialCodeSearch = (value) => {
    if (value.length >= 2) {
      RequestHandler.get(
        `/TransactionProjectType?$select=id,projectCode,name,projectType&$filter=((${odata.contains(
          "name",
          value
        )} or ${odata.contains(
          "projectCode",
          value
        )}) or ishhDefault eq true)  and ProjectType eq 9 and Name ne 'Diğer'&$orderby=ishhdefault desc`
      ).then((res) => {
        if (res.value) {
          setSpecialCodes({ data: res.value, loading: false });
        } else {
          setSpecialCodes({ data: [], loading: false });
        }
      });
    }
  };

  const onSpecialActionCodeSearch = (value) => {
    if (value.length >= 1) {
      RequestHandler.get(
        `/TransactionProjectType?$select=id,projectCode,name,projectType&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains(
          "projectCode",
          value
        )})  and ProjectType eq 1 and Name ne 'Diğer'`
      ).then((res) => {
        if (res.value) {
          setSpecialActionCodes({ data: res.value, loading: false });
        } else {
          setSpecialActionCodes({ data: [], loading: false });
        }
      });
    }
  };

  const getGroupNumbers = () => {
    RequestHandler.get(
      `/TransactionProjectType?$count=true&$filter=ProjectType eq 7 and IsActive eq true`
    ).then((res) => {
      setGroupNumbers({
        data: res.value,
        loading: false,
      });
    });
  };
  const onCosCenterSearch = (value) => {
    if (value.length >= 1) {
      RequestHandler.get(
        `/TransactionProjectType?$select=id,projectCode,name,projectType&$filter=((${odata.contains(
          "name",
          value
        )} or ${odata.contains(
          "projectCode",
          value
        )}) or ishhDefault eq true)  and ProjectType eq 2 and Name ne 'Diğer'`
      ).then((res) => {
        if (res.value) {
          setCosCenter({ data: res.value, loading: false });
        } else {
          setCosCenter({ data: [], loading: false });
        }
      });
    }
  };

  const onReferenceCodeSearch = (value) => {
    if (value.length >= 1) {
      RequestHandler.get(
        `/TransactionProjectType?$select=id,projectCode,name,projectType&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains(
          "projectCode",
          value
        )})  and ProjectType eq 8 and Name ne 'Diğer'`
      ).then((res) => {
        if (res.value) {
          setReferenceCode({ data: res.value, loading: false });
        } else {
          setReferenceCode({ data: [], loading: false });
        }
      });
    }
  };

  const onConfirmSuccessfulExport = () => {
    let isSuccess = true;
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );

    if (
      selectedRowsData.some((row) => row.isDuplicateTransaction) &&
      tableDataQueryOptions.activeTab !== "3"
    ) {
      notification.error({
        message: "Seçili hesap hareketleri içerisinde kopya hareketler var.",
        duration: 3,
      });
      isSuccess = false;
    }
    if (isSuccess) {
      selectedRowsData.map((item) => {
        if (item.firmClassId === null) {
          item.firmClassId = "00000000-0000-0000-0000-000000000000";
        }
        if (item.firmId === null) {
          item.firmId = "00000000-0000-0000-0000-000000000000";
        }
      });

      RequestHandler.post(
        "/ErpAccountTransaction/SetSuccessfulTransfer",
        selectedRowsData
      ).then((response) => {
        if (response.success) {
          getTableData();
        }
      });
    }
    setFilterSummary(true);
  };

  const onConfirmNotTransferredExport = () => {
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );
    RequestHandler.post(
      "/ErpAccountTransaction/SetNotTransferredTransfer",
      selectedRowsData
    ).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
    setFilterSummary(true);
  };

  const onConfirmVirmanOkExport = () => {
    const filteredData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );
    const selectedRowsData = columnSettings?.isHasCenterOfResponsibility
      ? filteredData.map((row) => {
          const centerOfResponsibilityCode = row.chaResponsibilityCode
            ? chaResponsbilityCodes.data.find(
                (item) => item.projectCode === row.chaResponsibilityCode
              )
            : chaResponsbilityCodes.data.find(
                (item) => item.id === row.centerOfResponsibilityCodeId
              );

          return {
            ...row,
            centerOfResponsibilityCodeId:
              centerOfResponsibilityCode?.id || null,
            chaResponsibilityCode:
              centerOfResponsibilityCode?.projectCode || null,
          };
        })
      : filteredData;

    if (props.transactionProcessType === 1) {
      const toSetVirmanTransactionsIds = matchedVirmanTransactions
        .filter((item) =>
          selectedVirmanTransactions.some((element) => element.id === item.id)
        )
        .map((x) => x.virmanMatchTransactionId);

      if (matchedVirmanTransactions.length > 0) {
        RequestHandler.post(
          "/ErpAccountTransaction/SetVirmanTransaction",
          matchedVirmanTransactions
        ).then((response) => {
          if (response.success) {
            setVirmanTransactions([]);
            setMatchedVirmanTransactions([]);
            setSelectedVirmanTransactions([]);

            RequestHandler.post(
              "/ErpAccountTransaction",
              selectedRowsData
            ).then((response) => {
              if (response.success) {
                getTableData();
              }
            });
          }
        });
      } else {
        RequestHandler.post("/ErpAccountTransaction", selectedRowsData).then(
          (response) => {
            if (response.success) {
              getTableData();
            }
          }
        );
      }
    }
    if (
      props.transactionProcessType === 2 &&
      columnSettings.isHasVirmanTransaction
    ) {
      const toSetSuccessfulTranferTransactions = virmanTransactions.filter(
        (item) =>
          selectedVirmanTransactions.some((element) => element.id !== item.id)
      );

      if (selectedVirmanTransactions.length === 0) {
        virmanTransactions.map((item) => {
          toSetSuccessfulTranferTransactions.push(item);
        });
      }

      const toSetTransferringTransactions = selectedRowsData.filter((item) =>
        toSetSuccessfulTranferTransactions.some(
          (element) => element.id !== item.id
        )
      );

      if (toSetSuccessfulTranferTransactions.length === 0) {
        virmanTransactions.map((item) => {
          toSetTransferringTransactions.push(item);
        });
      }

      if (toSetSuccessfulTranferTransactions.length > 0) {
        RequestHandler.post(
          "/ErpAccountTransaction/SetSuccessfulTransfer",
          toSetSuccessfulTranferTransactions
        ).then((response) => {
          if (response.success) {
            getTableData();
            setVirmanTransactions([]);
            setMatchedVirmanTransactions([]);
            setSelectedVirmanTransactions([]);

            if (toSetTransferringTransactions.length > 0) {
              RequestHandler.post(
                "/ErpAccountTransaction",
                toSetTransferringTransactions
              );
            }
          }
        });
      } else {
        RequestHandler.post(
          "/ErpAccountTransaction",
          toSetTransferringTransactions
        ).then((response) => {
          if (response.success) {
            getTableData();
            setVirmanTransactions([]);
            setMatchedVirmanTransactions([]);
            setSelectedVirmanTransactions([]);
          }
        });
      }
    }
  };

  const onConfirmIsCheckedExport = () => {
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );
    RequestHandler.post(
      "/ErpAccountTransaction/SetChecked",
      selectedRowsData
    ).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const onConfirmDoubleCheckForLogo = () => {
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );
    if (
      !selectedRowsData.every(
        (row) =>
          firmClass.data.some(
            (firmClassHasErpValue) =>
              firmClassHasErpValue.id === row.firmClassId
          ) &&
          row.firmId &&
          row.firmId !== "00000000-0000-0000-0000-000000000000"
      )
    ) {
      notification.error({
        message:
          "Seçili hesap hareketleri içerisinde 'Tip' veya 'Cari' seçilmemiş kayıtlar var.",
        duration: 3,
      });
      return;
    }
    RequestHandler.post(
      "/ErpAccountTransaction/DoubleCheckForLogo",
      selectedRowsData,
      false
    ).then((response) => {
      if (response) {
        setLogoCheckData(response);
        setVisibleLogoCheckTransactionModal(true);
      }
    });
  };

  const onConfirmVirmanSetSuccessfulExport = () => {
    setVirmanPopConfirmVisible(false);
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );

    selectedRowsData.forEach((item) => {
      if (virmanTransactions.some((c) => c.id == item.id)) {
        item.isSetSuccessful = true;
      }
    });

    RequestHandler.post("/ErpAccountTransaction", selectedRowsData).then(
      (response) => {
        if (response.success) {
          getTableData();
        }
      }
    );
  };
  const onTabChange = (tabKey) => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      activeTab: tabKey,
    });
    setTabKeyValue(tabKey);

    if (tabKey === "1") {
      setIsCheckedColumnVisible(true);
    } else {
      setIsCheckedColumnVisible(false);
    }
  };

  const onClickMatchFirm = (isUpdate, data) => {
    setFirmMatchFormData(data);
    setFirmMatchModal({ isUpdate: isUpdate, isVisible: true });
  };

  const getColumns = () => {
    const columnsBeforeDynamicColumns = [
      {
        title: "Banka",
        dataIndex: "bankLogo",
        width: "8%",
        render: (text) => <img src={text}></img>,
      },
      {
        title: "IBAN / Hesap No",
        dataIndex: "ibanOrAccountNumber",
        width: "1%",
        render: (data, row) => {
          if (showAccountName) {
            return row.tenantAccountName;
          }

          return data;
        },
      },
      {
        title: "Tutar",
        dataIndex: "amount",
        align: "right",
        editable: true,
        render: (data, row) => {

          return <span style={{ whiteSpace: "nowrap" }}>{row.isAmountChange ?  FormatMoney(row.changedAmount, row.currencyCode, props.transactionProcessType) : FormatMoney(data, row.currencyCode, props.transactionProcessType) }   {row.isCommission ? <Tooltip title="Komisyon tutarının aktarılabilmesi için oluşturuldu."><QuestionCircleOutlined /></Tooltip> : row.isAmountChange ? <Tooltip title="Komisyonlu tutarın aktarılabilmesi için tutar bilgisi güncellendi."><InfoCircleOutlined /></Tooltip> : ""}  </span>
        }
      },
      {
        title: "Tarih",
        dataIndex: "transactionDate",
        render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
      },
      {
        title: "Cari",
        dataIndex: "firmId",
        width: "15%",
        render: (data, row, index) => (
          <Select
            allowClear
            showSearch
            placeholder="En az 2 harf giriniz.."
            defaultValue={data ?? undefined}
            disabled={!isExportAvailable}
            style={{ width: "100%" }}
            dropdownStyle={{ minWidth: "50%" }}
            onSearch={onFirmSearch}
            onChange={(value, option) => {
              let rows = [...tableData.data];
              let rowToUpdate = {
                ...row,
                firmId: value,
                firmName: option?.firmName,
                firmClassId:
                  option?.firmClassName === "Cari"
                    ? erpType
                      ? erpType.id || option
                      : option?.firmClassId
                    : option?.firmClassId,
                firmClassName:
                  option?.firmClassName === "Cari"
                    ? erpType
                      ? erpType.name || option
                      : option?.firmClassName
                    : option?.firmClassName,
                firmBranchNumber: option?.firmBranchNumber,
                chequeNumbers: [],
                chequeNumber: option?.chequeNumber,
                firmVknCount: option?.vkncount,
                firmCurrencyCount: option?.currencyCount,
                firmBalances: option?.firmBalances,
                currency: option?.currencyType,
                divisionId: transactionProjectTypes.some(
                  (i) => i.id == option?.divisionId
                )
                  ? option?.divisionId
                  : undefined,
                deparmentId: transactionProjectTypes.some(
                  (i) => i.id == option?.deparmentId
                )
                  ? option?.deparmentId
                  : undefined,
                firmClassIsBankType: option?.firmClassIsBankType || false,
              };
              rows[index] = rowToUpdate;
              setTableData({ ...tableData, data: rows });
            }}
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
          >
            {data && (
              <Select.Option
                key={row.firmId}
                value={row.firmId}
                firmName={row.firmName}
                firmClassId={row.firmClassId}
                firmBranchNumber={row.firmBranchNumber}
                firmClassName={row.firmClassName}
                vkncount={row.firmVknCount}
                currencyCount={row.firmCurrencyCount}
                firmBalances={row.firmBalances}
                currencyType={row.currencyType}
                divisionId={row.divisionId}
                deparmentId={row.deparmentId}
                firmClassIsBankType={row.firmClassIsBankType}
              >
                {row.firmBranchNumber
                  ? `${row.firmName} (${row.firmBranchNumber}) ${
                      row.firmClassExpireDate
                        ? moment(row.firmClassExpireDate).format("DD.MM.YYYY")
                        : ""
                    }`
                  : `${row.firmName} ${
                      row.firmClassExpireDate
                        ? moment(row.firmClassExpireDate).format("DD.MM.YYYY")
                        : ""
                    }`}
              </Select.Option>
            )}

            {firm
              .filter((item) => item.id != data)
              .map((item) => (
                <Select.Option
                  key={item.id}
                  value={item.id}
                  firmName={item.name}
                  firmClassId={item.firmClassId}
                  firmBranchNumber={item.firmBranchNumber}
                  firmClassName={item.firmClassName}
                  vkncount={item.vknCount}
                  currencyCount={item.currencyCount}
                  firmBalances={item.firmBalances}
                  currencyType={item.currencyType}
                  divisionId={item.divisionId}
                  deparmentId={item.deparmentId}
                  firmClassIsBankType={item.firmClassIsBankType}
                >
                  {item.firmBranchNumber
                    ? `${item.name} (${item.firmBranchNumber}) ${
                        item.firmClassExpireDate
                          ? moment(item.firmClassExpireDate).format(
                              "DD.MM.YYYY"
                            )
                          : ""
                      }`
                    : `${item.name} ${
                        row.firmClassExpireDate
                          ? moment(item.firmClassExpireDate).format(
                              "DD.MM.YYYY"
                            )
                          : ""
                      }`}
                </Select.Option>
              ))}
          </Select>
        ),
      },
      {
        title: "Tip",
        dataIndex: "firmClassId",
        width: "10%",
        render: (data, row, index) => {
          const firmClassAvailable = firmClass.data.some((e) => e.id === data);

          return (
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              value={firmClassAvailable ? data : undefined}
              disabled={!isExportAvailable}
              style={{ width: "100%" }}
              loading={firmClass.loading}
              onChange={(value, option) => {
                let rows = [...tableData.data];
                if (
                  columnSettings?.isHasChequeNumber &&
                  option?.children.toLocaleLowerCase("tr-TR") == "çek" &&
                  row.firmId != null
                ) {
                  RequestHandler.post(
                    `/ErpOnare/GetChequeNumbers`,
                    {
                      firmBranchNumber: row.firmBranchNumber,
                    },
                    false,
                    { rawResponse: true }
                  ).then((res) => {
                    let rowToUpdate = {
                      ...row,
                      firmClassId: value,
                      chequeNumbers:
                        res.status == 200
                          ? res.data != ""
                            ? res.data
                            : []
                          : [],
                      firmClassName: option?.children,
                      chequeNumber: option?.chequeNumber,
                      firmClassIsBankType: option?.isBankType || false,
                    };
                    rows[index] = rowToUpdate;
                    setTableData({ ...tableData, data: rows });
                  });
                } else {
                  let rowToUpdate = {
                    ...row,
                    firmClassId: value,
                    chequeNumbers: [],
                    firmClassName: option?.children,
                    chequeNumber: option?.chequeNumber,
                    firmClassIsBankType: option?.isBankType || false,
                  };
                  rows[index] = rowToUpdate;

                  setTableData({ ...tableData, data: rows });
                }

                if (option?.children.toLocaleLowerCase("tr-TR") == "senet") {
                  getFirmByClassName("senet");
                }
              }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {firmClass.data.map((item) => {
                return (
                  <Select.Option
                    key={item.id}
                    value={item.id}
                    isBankType={item.isBankType}
                  >
                    {item.name}
                  </Select.Option>
                );
              })}
            </Select>
          );
        },
      },
    ];

    if (isDivisionAndDeparment) {
      columnsBeforeDynamicColumns.push({
        width: "7%",
        title: "Bölüm Kodu",
        dataIndex: "divisionId",
        render: (data, row, index) => {
          return (
            <Select
              allowClear
              disabled={!isExportAvailable}
              placeholder="Seçiniz"
              value={data ?? undefined}
              style={{ width: "100%" }}
              onChange={(value) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  divisionId: value,
                };
                rows[index] = rowToUpdate;
                setTableData({ ...tableData, data: rows });
              }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {transactionProjectTypes
                .filter((item) => item.projectType == 5)
                .map((item) => (
                  <Select.Option key={item.id}>
                    {item.name} ({item.projectCode})
                  </Select.Option>
                ))}
            </Select>
          );
        },
      });
      columnsBeforeDynamicColumns.push({
        width: "7%",
        title: "Departman Kodu",
        dataIndex: "deparmentId",
        render: (data, row, index) => {
          return (
            <Select
              allowClear
              disabled={!isExportAvailable}
              placeholder="Seçiniz"
              value={data ?? undefined}
              style={{ width: "100%" }}
              onChange={(value) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  deparmentId: value,
                };
                rows[index] = rowToUpdate;
                setTableData({ ...tableData, data: rows });
              }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {transactionProjectTypes
                .filter((item) => item.projectType == 6)
                .map((item) => (
                  <Select.Option key={item.id}>
                    {item.name} ({item.projectCode})
                  </Select.Option>
                ))}
            </Select>
          );
        },
      });
    }

    if (operationType) {
      columnsBeforeDynamicColumns.push({
        title: "İşlem Türü",
        dataIndex: "operationType",
        render: (data, row, index) => {
          return (
            <Select
              allowClear
              disabled={!isExportAvailable}
              placeholder="Seçiniz"
              value={data ?? undefined}
              defaultValue={data ?? undefined}
              style={{ width: "100%" }}
              onChange={(value) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  operationType: value,
                };
                rows[index] = rowToUpdate;
                setTableData({ ...tableData, data: rows });
              }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {operationTypes.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          );
        },
      });
    }
    if (operationType2) {
      columnsBeforeDynamicColumns.push({
        title: "2.İşlem Türü",
        dataIndex: "operationType2",
        render: (data, row, index) => {
          return (
            <Select
              allowClear
              disabled={!isExportAvailable}
              placeholder="Seçiniz"
              defaultValue={data ?? undefined}
              style={{ width: "100%" }}
              onChange={(value) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  operationType2: value,
                };
                rows[index] = rowToUpdate;
                setTableData({ ...tableData, data: rows });
              }}
              w
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {operationTypes.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          );
        },
      });
    }

    if (cardType) {
      columnsBeforeDynamicColumns.push({
        title: "Banka Türü",
        dataIndex: "cardType",
        width: "10%",

        render: (data, row, index) => {
          return (
            <Select
              style={{ width: "100%" }}
              defaultValue={data ?? undefined}
              disabled={!isExportAvailable}
              allowClear
              placeholder="Seçiniz"
              onChange={(value) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  cardType: value,
                };
                rows[index] = rowToUpdate;
                setTableData({ ...tableData, data: rows });
              }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {cardTypeSelect.map(({ key, value }) => (
                <Select.Option key={key} value={key}>
                  {value}
                </Select.Option>
              ))}
            </Select>
          );
        },
      });
    }
    //     WHEN 1 THEN ''Ticari Hesap''
    // WHEN 2 THEN ''Kredi Hesabı''
    // WHEN 3 THEN ''Dövizli Ticari Hesap''
    // WHEN 4 THEN ''Dövizli Kredi Hesabı''
    // WHEN 5 THEN ''Kredi Kartı Hesabı''
    // WHEN 6 THEN ''Dövizli Kredi Kartı Hesabı''

    if (columnSettings?.isUseFirmVknCount) {
      columnsBeforeDynamicColumns.push({
        title: "Cari Vkn Adet",
        dataIndex: "firmVknCount",
        width: "8%",
        align: "center",
      });
    }

    if (columnSettings?.isDynamicDescriptionToMikro) {
      columnsBeforeDynamicColumns.push({
        title: "Cari Döviz Adet",
        dataIndex: "firmCurrencyCount",
        width: "8%",
        align: "center",
      });
    }

    if (columnSettings?.isShowBalanceColumn) {
      columnsBeforeDynamicColumns.push({
        title: "Cari Tutar",
        width: "8%",
        align: "center",
        dataIndex: "firmBalances",
        render: (data, row) => {
          if (data.length > 0) {
            const rows = data.map((item, index) => (
              <React.Fragment key={index}>
                {item.balance}
                {index < data.length - 1 ? <br /> : ""}
              </React.Fragment>
            ));

            return <span style={{ whiteSpace: "nowrap" }}>{rows}</span>;
          }

          return "-";
        },
      });
    }

    if (columnSettings?.isHasCenterOfResponsibility) {
      columnsBeforeDynamicColumns.push({
        title: "Sorumluluk Merkezi",
        dataIndex: "chaResponsibilityCode",
        width: "8%",
        render: (data, row, index) => {
          if (columnSettings?.isUseSelectBoxForResponsibilityCenter) {
            return (
              <Select
                allowClear
                showSearch
                placeholder="Seçiniz"
                value={
                  data
                    ? data
                    : defaultChaResponsbilityCode
                    ? defaultChaResponsbilityCode
                    : undefined
                }
                style={{ width: "100%" }}
                dropdownStyle={{ minWidth: "30%" }}
                loading={chaResponsbilityCodes.loading}
                onSearch={onChaCodeSearch}
                onChange={(value, option) => {
                  let rows = [...tableData.data];
                  let rowToUpdate = {
                    ...row,
                    chaResponsibilityCode: value ?? defaultChaResponsbilityCode,
                    centerOfResponsibilityCodeId: option
                      ? option.key
                      : defaultChaResponsbilityCodeId,
                  };
                  rows[index] = rowToUpdate;

                  setTableData({ ...tableData, data: rows });
                }}
                filterOption={(input, option) =>
                  option.children
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                }
                disabled={!isExportAvailable}
              >
                {data && (
                  <Select.Option
                    key={row.chaResponsibilityCodeId}
                    value={row.chaResponsibilityCode}
                    name={row.chaResponsibilityCodeName}
                    projectCode={row.chaResponsibilityCode}
                  >
                    {row.chaResponsibilityCode
                      ? `${row.chaResponsibilityCodeName} (${row.chaResponsibilityCode})`
                      : row.chaResponsibilityCodeName}
                  </Select.Option>
                )}

                {chaResponsbilityCodes.data
                  .filter((item) => item.id != row.chaResponsibilityCodeId)
                  .map((item) => {
                    return (
                      <Select.Option key={item.id} value={item.projectCode}>
                        {`${item.name} - (${item.projectCode})`}
                      </Select.Option>
                    );
                  })}
              </Select>
            );
          }

          return (
            <Input
              value={data}
              disabled={!isExportAvailable}
              onChange={(event) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  chaResponsibilityCode: event.target.value,
                };
                rows[index] = rowToUpdate;

                setTableData({ ...tableData, data: rows });
              }}
            />
          );
        },
      });
    }

    if (columnSettings?.isHasSpecialCode) {
      columnsBeforeDynamicColumns.push({
        title: "Özel Kod",
        dataIndex: "specialCode",
        width: "8%",
        render: (data, row, index) => {
          return (
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              value={
                data
                  ? data
                  : defaultSpecialCode
                  ? defaultSpecialCode
                  : undefined
              }
              style={{ width: "100%" }}
              loading={specialCodes.loading}
              onSearch={onSpecialCodeSearch}
              onChange={(value, option) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  specialCodeId: option ? option?.key : defaultSpecialCodeId,
                  specialCode: option ? option?.value : defaultSpecialCode,
                };
                rows[index] = rowToUpdate;

                setTableData({ ...tableData, data: rows });
              }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              disabled={!isExportAvailable}
            >
              {data && (
                <Select.Option key={data} value={row.specialCode}>
                  {`${row.specialCodeName} - (${row.specialCode})`}
                </Select.Option>
              )}

              {specialCodes.data
                .filter((i) => i.projectType == 9)
                .map((item) => {
                  return (
                    <Select.Option key={item.id} value={item.projectCode}>
                      {`${item.name} - (${item.projectCode})`}
                    </Select.Option>
                  );
                })}
            </Select>
          );
        },
      });
    }

    if (columnSettings?.isHasBankCenterOfResponsibility) {
      columnsBeforeDynamicColumns.push({
        title: "Banka Sorumluluk Merkezi",
        dataIndex: "bankResponsibilityCode",
        width: "8%",
        render: (data, row, index) => {
          return (
            <Input
              value={data}
              disabled={!isExportAvailable}
              onChange={(event) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  bankResponsibilityCode: event.target.value,
                };
                rows[index] = rowToUpdate;

                setTableData({ ...tableData, data: rows });
              }}
            />
          );
        },
      });
    }

    if (
      columnSettings?.isHasProjectCode &&
      columnSettings.isHasMatchAccountTransactionRule
    ) {
      columnsBeforeDynamicColumns.push({
        title: "Proje Kodu",
        dataIndex: "transactionProjectTypeId",
        width: "15%",
        render: (data, row, index) => {
          if (
            columnSettings?.isDynamicDescriptionToMikro &&
            data == null &&
            isExportAvailable
          ) {
            const description = row.description.toLocaleLowerCase();
            const pattern = /(KM-|km-|CX-|cx-)[0-9]*/;
            const matchValue = description.match(pattern);

            if (matchValue != null) {
              let projectCode = matchValue[0];
              let projectCodeValue =
                projectCode.length > 0 ? projectCode : data;

              const project = allProjects.find(
                (x) =>
                  x.projectCode.toLocaleLowerCase() ==
                  projectCodeValue.toLocaleLowerCase()
              );

              if (project != null) {
                row.transactionProjectTypeId = project.id;
                row.transactionProjectTypeName = project.name;
                row.projectCode = project.projectCode;

                data = `${row.transactionProjectTypeName} (${row.projectCode})`;
              }
            }
          }

          return (
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              value={
                data
                  ? data
                  : defaultProjectCodeId
                  ? defaultProjectCodeId
                  : undefined
              }
              disabled={!isExportAvailable}
              style={{ width: "100%" }}
              dropdownStyle={{ minWidth: "30%" }}
              loading={projects.loading}
              onSearch={onProjectSearch}
              onChange={(value, option) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  transactionProjectTypeId: value
                    ? value
                    : defaultProjectCodeId
                    ? defaultProjectCodeId
                    : null,
                  transactionProjectTypeName: option
                    ? option?.name
                    : defaultProjectCode,
                  projectCode: option
                    ? option?.projectCode
                    : defaultProjectCode,
                };
                rows[index] = rowToUpdate;
                setTableData({ ...tableData, data: rows });
              }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {data && (
                <Select.Option
                  key={row.transactionProjectTypeId}
                  value={row.transactionProjectTypeId}
                  name={row.transactionProjectTypeName}
                  projectCode={row.projectCode}
                >
                  {row.projectCode
                    ? `${row.transactionProjectTypeName} (${row.projectCode})`
                    : row.transactionProjectTypeName}
                </Select.Option>
              )}
              {projects.data
                .filter((item) => item.id != data)
                .map((item) => (
                  <Select.Option
                    key={item.id}
                    value={item.id}
                    name={item.name}
                    projectCode={item.projectCode}
                  >
                    {item.name + " (" + item.projectCode + ")"}
                  </Select.Option>
                ))}
            </Select>
          );
        },
      });
    }


    if(columnSettings?.isHasCreateProjectCodeFromDescription) {

      columnsBeforeDynamicColumns.push({
        title: "Proje Kodu",
        dataIndex: "description",
        render: (data,row,index) => {
          const pattern = /\b\d{2}[A-ZÇĞİÖŞÜ]{1,3}\d{2,4}\b/u;

          const match = data.match(pattern);

          if(match) {
            return `003-${match[0]}`;
          }

          return "";
        }
      })

    }

    if (columnSettings?.isHasSpecialMoveCode) {
      columnsBeforeDynamicColumns.push({
        title: "Özel Hareket Kodu",
        dataIndex: "erpTransactionProjectTypeId",
        width: "15%",
        render: (data, row, index) => (
          <Select
            allowClear
            showSearch
            placeholder="Seçiniz"
            defaultValue={data ?? undefined}
            disabled={!isExportAvailable}
            style={{ width: "100%" }}
            dropdownStyle={{ minWidth: "30%" }}
            loading={specialActionCodes.loading}
            onSearch={onSpecialActionCodeSearch}
            onChange={(value, option) => {
              let rows = [...tableData.data];
              let rowToUpdate = {
                ...row,
                erpTransactionProjectTypeId: value,
                erpTransactionProjectTypeName: option?.name,
                erpTransactionProjectTypeCode: option?.projectCode,
              };
              rows[index] = rowToUpdate;
              setTableData({ ...tableData, data: rows });
            }}
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
          >
            {data && (
              <Select.Option
                key={row.erpTransactionProjectTypeId}
                value={row.erpTransactionProjectTypeId}
                name={row.erpTransactionProjectTypeName}
                projectCode={row.erpTransactionProjectTypeCode}
              >
                {row.erpTransactionProjectTypeCode
                  ? `${row.erpTransactionProjectTypeName} (${row.erpTransactionProjectTypeCode})`
                  : row.erpTransactionProjectTypeName}
              </Select.Option>
            )}

            {specialActionCodes.data
              .filter((item) => item.id != data)
              .map((item) => (
                <Select.Option
                  key={item.id}
                  value={item.id}
                  name={item.name}
                  projectCode={item.projectCode}
                >
                  {item.name + " (" + item.projectCode + ")"}
                </Select.Option>
              ))}
          </Select>
        ),
      });
    }

    if (columnSettings?.isUseGroupNumber) {
      columnsBeforeDynamicColumns.push({
        title: "Grup Numarası",
        dataIndex: "groupNumber",
        width: "15%",
        render: (data, row, index) => (
          <Select
            allowClear
            showSearch
            placeholder="Seçiniz"
            value={data}
            style={{ width: "100%" }}
            loading={groupNumbers.loading}
            onChange={(value, option) => {
              let rows = [...tableData.data];

              let rowToUpdate = {
                ...row,
                groupNumber: value,
              };
              rows[index] = rowToUpdate;

              setTableData({ ...tableData, data: rows });
            }}
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
            disabled={!isExportAvailable}
          >
            {groupNumbers.data.map((item) => {
              return (
                <Select.Option key={item.id} value={item.projectCode}>
                  {`${item.name} - (${item.projectCode})`}
                </Select.Option>
              );
            })}
          </Select>
        ),
      });
    }

    if (columnSettings?.isHasCosCenter) {
      columnsBeforeDynamicColumns.push({
        title: `${
          columnSettings.erpProgramId == 8 ? "Maliyet" : "Masraf"
        }  Merkezi`,
        dataIndex: "cosCenterCode",
        width: "15%",
        render: (data, row, index) => {
          return (
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              defaultValue={
                data
                  ? data
                  : defaultCosCenter.projectCode
                  ? defaultCosCenter.projectCode
                  : undefined
              }
              disabled={!isExportAvailable}
              style={{ width: "100%" }}
              dropdownStyle={{ minWidth: "30%" }}
              loading={cosCenters.loading}
              onChange={(value, option) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  cosCenterId: value
                    ? value
                    : defaultCosCenter.id
                    ? defaultCosCenter.id
                    : null,
                  cosCenterName: option ? option?.name : defaultCosCenter.name,
                  cosCenterCode: option
                    ? option?.projectCode
                    : defaultCosCenter.projectCode,
                };
                rows[index] = rowToUpdate;
                setTableData({ ...tableData, data: rows });
              }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {cosCenters.data.map((item) => (
                <Select.Option
                  key={item.id}
                  value={item.projectCode}
                  name={item.name}
                  projectCode={item.projectCode}
                >
                  {item.name + " (" + item.projectCode + ")"}
                </Select.Option>
              ))}
            </Select>
          );
        },
      });
    }

    if (columnSettings?.isHasSecondCosCenter) {
      columnsBeforeDynamicColumns.push({
        title: `2. Masraf Merkezi`,
        dataIndex: "secondCosCenterCode",
        width: "15%",
        render: (data, row, index) => {
          return (
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              defaultValue={data}
              disabled={!isExportAvailable}
              style={{ width: "100%" }}
              dropdownStyle={{ minWidth: "30%" }}
              loading={cosCenters.loading}
              onChange={(value, option) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  secondCosCenterId: value,
                  secondCosCenterName: option?.name,
                  secondCosCenterCode: option?.projectCode,
                };
                rows[index] = rowToUpdate;
                setTableData({ ...tableData, data: rows });
              }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {cosCenters.data.map((item) => (
                <Select.Option
                  key={item.id}
                  value={item.projectCode}
                  name={item.name}
                  projectCode={item.projectCode}
                >
                  {item.name + " (" + item.projectCode + ")"}
                </Select.Option>
              ))}
            </Select>
          );
        },
      });
    }

    if (
      columnSettings?.isHasProjectCode &&
      !columnSettings?.isHasMatchAccountTransactionRule
    ) {
      if (tenantIdList.includes(localStorage.getItem("tenantId"))) {
        columnsBeforeDynamicColumns.push({
          title: "Proje Kodu",
          dataIndex: "projectCode",
          width: "15%",
          render: (data, row, index) => (
            <Input
              style={{ width: 75 }}
              defaultValue={
                data ??
                (row.description.startsWith("GX-") ||
                row.description.startsWith("KMARGE-")
                  ? row.description.split("-")[1].substring(0, 5)
                  : undefined)
              }
              disabled={!isExportAvailable}
              onChange={(event) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  projectCode: event.target.value,
                };
                rows[index] = rowToUpdate;

                setTableData({ ...tableData, data: rows });
              }}
            />
          ),
        });
      } else {
        columnsBeforeDynamicColumns.push({
          title: "Proje Kodu",
          dataIndex: "projectCode",
          width: "15%",
          render: (data, row, index) => (
            <Input
              defaultValue={data ?? undefined}
              disabled={!isExportAvailable}
              onChange={(event) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  projectCode: event.target.value,
                };
                rows[index] = rowToUpdate;

                setTableData({ ...tableData, data: rows });
              }}
            />
          ),
        });
      }
    }

    if (columnSettings?.isHasChequeNumber) {
      columnsBeforeDynamicColumns.push({
        title: "Çek Numarası",
        dataIndex: "chequeNumber",
        width: "15%",
        render: (data, row, index) => {
          return (
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              disabled={
                !isExportAvailable ||
                row.firmId == null ||
                row.firmClassName?.toLocaleLowerCase("tr-TR") != "çek"
              }
              value={row.chequeNumber}
              style={{ width: "100%" }}
              onChange={(value) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  chequeNumber: value,
                };
                rows[index] = rowToUpdate;
                setTableData({ ...tableData, data: rows });
              }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {row.chequeNumbers?.map((item) => (
                <Select.Option key={item.CHEQUE_ID} value={item.CHEQUE_NO}>
                  {item.CHEQUE_NO} ({item.CHEQUE_VALUE} - {item.CURRENCY_ID})
                </Select.Option>
              ))}
            </Select>
          );
        },
      });
    }

    if (columnSettings?.isHasReferenceCode) {
      if (columnSettings?.isHasReferenceCodeSelectable) {
        columnsBeforeDynamicColumns.push({
          title: "Referans Kodu",
          dataIndex: "referenceCode",
          key: "referenceCode",
          width: "15%",
          render: (data, row, index) => (
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              disabled={!isExportAvailable || row.firmId == null}
              value={
                tableDataQueryOptions.activeTab == 0
                  ? undefined
                  : row.referenceCode
              }
              dropdownStyle={{ minWidth: "30%" }}
              loading={referenceCodes.loading}
              onSearch={onReferenceCodeSearch}
              style={{ width: "100%" }}
              onChange={(value) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  referenceCode: value,
                };
                rows[index] = rowToUpdate;
                setTableData({ ...tableData, data: rows });
              }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {referenceCodes?.data?.map((item) => (
                <Select.Option
                  key={item.projectCode}
                  value={item.projectCode}
                  name={item.name}
                  projectCode={item.projectCode}
                >
                  {item.name + " (" + item.projectCode + ")"}
                </Select.Option>
              ))}
            </Select>
          ),
        });
      } else {
        columnsBeforeDynamicColumns.push({
          title: "Referans Kodu",
          dataIndex: "referenceCode",
          key: "referenceCode",
          width: "15%",
          render: (data, row, index) => (
            <Input
              value={row.referenceCode}
              defaultValue={data}
              disabled={!isExportAvailable || row.firmId == null}
              onChange={(event) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  referenceCode: event.target.value,
                };
                rows[index] = rowToUpdate;

                setTableData({ ...tableData, data: rows });
              }}
            />
          ),
        });
      }
    }
    if (columnSettings?.isHasMatchAccountTransactionRule) {
      columnsBeforeDynamicColumns.push({
        title: "Erp Açıklama",
        dataIndex: "erpDescription",
        width: "20%",
        render: (data, row, index) => {
          return (
            <TextArea
              value={data}
              disabled={!isExportAvailable}
              onChange={(event) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  erpDescription: event.target.value,
                };
                rows[index] = rowToUpdate;

                setTableData({ ...tableData, data: rows });
              }}
              style={{ width: "100%", minWidth: "50%" }}
            />
          );
        },
      });
    }

    if (isCheckedColumnVisible) {
      columnsBeforeDynamicColumns.push({
        title: "Kontrol",
        dataIndex: "isChecked",
        align: "center",
        render: (data) =>
          data === true ? (
            <a style={{ color: "green", fontSize: "130%" }}>
              <CheckCircleOutlined />
            </a>
          ) : (
            ""
          ),
      });
    }

    if (columnSettings?.isUseCurrencyExChangeRate) {
      if (tenantIdList.includes(localStorage.getItem("tenantId"))) {
        columnsBeforeDynamicColumns.push({
          title: "Döviz Kuru",
          dataIndex: "currencyExChangeRate",
          align: "center",
          render: (data, row, index) => (
            <Input
              defaultValue={
                !isExportAvailable || tabKeyValue === "3"
                  ? row.currencyExchangeRate
                  : (row.description.split(" ")[2] === "KUR"
                      ? parseFloat(
                          row.description.split(" ")[1].replace(",", ".")
                        )
                      : null) ??
                    data ??
                    undefined
              }
              disabled={!isExportAvailable}
              style={{ width: 87 }}
              type="number"
              onChange={(event) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  currencyExChangeRate: parseFloat(event.target.value),
                };
                rows[index] = rowToUpdate;

                setTableData({ ...tableData, data: rows });
              }}
            />
          ),
        });
      } else {
        columnsBeforeDynamicColumns.push({
          title: "Döviz Kuru",
          dataIndex: "currencyExchangeRate",
          align: "center",
          width: "8%",
          render: (data, row, index) => {
            if (
              columnSettings?.isDynamicDescriptionToMikro &&
              data == null &&
              isExportAvailable
            ) {
              const pattern = /[0-9]+,[0-9]+[0-9]+[0-9]+[0-9]/;
              const matchValue = row.description.match(pattern);

              if (matchValue != null) {
                data = matchValue[0].replace(",", ".");
              }
            }

            return (
              <Input
                defaultValue={data ?? undefined}
                disabled={!isExportAvailable}
                type="number"
                style={{ width: "100px" }}
                onChange={(event) => {
                  let rows = [...tableData.data];
                  let rowToUpdate = {
                    ...row,
                    currencyExchangeRate: event.target.value,
                  };
                  rows[index] = rowToUpdate;

                  setTableData({ ...tableData, data: rows });
                }}
              />
            );
          },
        });
      }
    }
    if (columnSettings?.isUseCurrencyExChangeType) {
      columnsBeforeDynamicColumns.push({
        title: "Döviz",
        dataIndex: "currency",
        align: "center",
        width: "8%",
        render: (data, row, index) => {
          return (
            <Select
              allowClear
              disabled={!isExportAvailable || isGo3SendExchangeRate}
              showSearch
              width={87}
              value={
                erpProgramId == "13"
                  ? isGo3SendExchangeRate
                    ? row.currency == null
                      ? "TRY"
                      : row.currency
                    : "TRY"
                  : undefined
              }
              defaultValue={
                !isExportAvailable || tabKeyValue === "3"
                  ? data
                  : currencySelect.data.find(
                      (currency) =>
                        currency.code ===
                        row.description.split(" ")[5]?.substring(0, 3)
                    )?.code !== undefined
                  ? row.description.split(" ")[5]?.substring(0, 3)
                  : "TRY"
              }
              placeholder="Seçiniz"
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              onChange={(value) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  currency: value,
                };
                rows[index] = rowToUpdate;
                setTableData({ ...tableData, data: rows });
              }}
              loading={currencySelect.loading}
              // disabled={activeCashAccount?.currencyId}
            >
              {currencySelect.data.map(({ id, code }) => (
                <Select.Option key={code} value={code}>
                  {code}
                </Select.Option>
              ))}
            </Select>
          );
        },
      });
    }

    if (columnSettings?.isHasLogoTransactionType) {
      columnsBeforeDynamicColumns.push({
        title: "İşlem Türü",
        dataIndex: "referenceCode",
        width: "15%",
        render: (data, row, index) => (
          <Select
            allowClear
            showSearch
            placeholder="Seçiniz"
            defaultValue={data ?? undefined}
            disabled={!isExportAvailable}
            style={{ width: "100%" }}
            dropdownStyle={{ minWidth: "30%" }}
            onChange={(value, option) => {
              let rows = [...tableData.data];
              let rowToUpdate = {
                ...row,
                referenceCode: value,
              };
              rows[index] = rowToUpdate;
              setTableData({ ...tableData, data: rows });
            }}
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
          >
            {data && (
              <Select.Option
                key={row.referenceCode}
                value={row.referenceCode}
                name={
                  logoTransactionTypes.find(
                    (c) => c.code == row.referenceCode
                  ) !== undefined
                    ? logoTransactionTypes.find(
                        (c) => c.code == row.referenceCode
                      ).name
                    : null
                }
                code={row.referenceCode}
              >
                {logoTransactionTypes.find(
                  (c) => c.code == row.referenceCode
                ) !== undefined
                  ? logoTransactionTypes.find(
                      (c) => c.code == row.referenceCode
                    ).name
                  : null}
              </Select.Option>
            )}

            {logoTransactionTypes
              .filter((item) => item.code != data)
              .map((item) => (
                <Select.Option
                  key={item.code}
                  value={item.code}
                  name={item.name}
                  code={item.code}
                >
                  {item.name}
                </Select.Option>
              ))}
          </Select>
        ),
      });
    }

    if(columnSettings?.isShowIban) {

        columnsBeforeDynamicColumns.push( {
          title: "Iban",
          dataIndex: "iban",
          render: (text,row,index) => {
            if(text) {
              return text;
            }

            return "-";
          }
        });
    }

    if (columnSettings?.isHasDuplicateTransaction) {
      return columnsBeforeDynamicColumns.concat([
        {
          title: "Açıklama",
          dataIndex: "description",
          render: (text, row, index) => (
            <Tooltip placement="topLeft" title={text}>
              <div style={{ whiteSpace: "break-spaces" }}>
                {text?.trim()?.length > 60
                  ? text.substring(0, 125) + "..."
                  : text}
              </div>
            </Tooltip>
          ),
        },
        {
          title: "Evrak No",
          dataIndex: "documentNumber",
        },
        {
          title: "Durum",
          dataIndex: "erpTransferStatusId",
          align: "center",
          render: (i, row) => {
            const icon = {
              0: {
                color: "blue",
                component: <InfoCircleOutlined />,
              },
              1: {
                color: "green",
                component: <CheckCircleOutlined />,
              },
              2: {
                color: "orange",
                component: <ClockCircleOutlined />,
              },
              3: {
                color: "red",
                component: <CloseCircleOutlined />,
              },
              4: {
                color: "green",
                component: <FileExcelOutlined />,
              },
            };
            return (
              <Tooltip
                title={
                  i === 3 && row.errorMessage
                  ? row.errorMessage
                  : row.erpTransferStatus
                }
              >
                <a style={{ fontSize: "130%", color: icon[i].color }}>
                  {icon[i].component}
                </a>
              </Tooltip>
            );
          },
        },
        {
          title: "Kopyala",
          dataIndex: "operation",
          align: "center",
          width: "1%",
          render: (data, row, index) =>
            tableDataQueryOptions.activeTab === "0" ? (
              row.isDuplicateTransaction === false ? (
                <Popconfirm
                  title="Kopyalamak istiyor musunuz?"
                  okText="Evet"
                  cancelText="Hayır"
                  onConfirm={() => onAdd(index, row)}
                >
                  <a style={{ color: "green", fontSize: "130%" }}>
                    <PlusOutlined />
                  </a>
                </Popconfirm>
              ) : (
                <Popconfirm
                  title="Silmek istiyor musunuz?"
                  okText="Evet"
                  cancelText="Hayır"
                  onConfirm={() => onDelete(row)}
                >
                  <a style={{ color: "red", fontSize: "130%" }}>
                    <DeleteOutlined />
                  </a>
                </Popconfirm>
              )
            ) : (
              ""
            ),
        },
        {
          title: "Düzenle",
          dataIndex: "operation",
          align: "center",
          render: (_, record) =>
            tableDataQueryOptions.activeTab === "0" ? (
              isEditing(record) === true ? (
                <span>
                  <Typography.Link
                    onClick={() => save(record.id)}
                    style={{
                      marginRight: 8,
                    }}
                  >
                    Kaydet
                  </Typography.Link>
                  <Popconfirm
                    title="İptal etmek istiyor musunuz?"
                    onConfirm={cancel}
                  >
                    <a>İptal</a>
                  </Popconfirm>
                </span>
              ) : (
                <Typography.Link
                  disabled={editingKey !== ""}
                  onClick={() => edit(record)}
                >
                  <EditOutlined
                    style={{ color: "orange", fontSize: "130%" }}
                  ></EditOutlined>
                </Typography.Link>
              )
            ) : (
              ""
            ),
        },
      ]);
    }

    return columnsBeforeDynamicColumns.concat([
      {
        title: "Açıklama",
        dataIndex: "description",
        render: (text, row, index) => (
          <Tooltip placement="topLeft" title={text}>
            <div style={{ whiteSpace: "break-spaces" }}>
              {text?.trim()?.length > 60
                ? text.substring(0, 125) + "..."
                : text}
            </div>
          </Tooltip>
        ),
      },
      {
        title: "Evrak No",
        dataIndex: "documentNumber",
      },
      {
        title: "Durum",
        dataIndex: "erpTransferStatusId",
        align: "center",
        render: (i, row) => {
          const icon = {
            0: {
              component: <InfoCircleOutlined />,
            },
            1: {
              color: "green",
              component: <CheckCircleOutlined />,
            },
            2: {
              color: "orange",
              component: <ClockCircleOutlined />,
            },
            3: {
              color: "red",
              component: <CloseCircleOutlined />,
            },
            4: {
              color: "green",
              component: <FileExcelOutlined />,
            },
          };
          return (
            <Tooltip
              title={
                i === 3 && row.errorMessage
                ? row.errorMessage
                : row.erpTransferStatus
              }
            >
              <a style={{ fontSize: "130%", color: icon[i].color }}>
                {icon[i].component}
              </a>
            </Tooltip>
          );
        },
      },
    ]);
  };

  const isExportAvailable =
    tableDataQueryOptions.activeTab === "0" ||
    tableDataQueryOptions.activeTab === "3";

  const isExportToSetNotTransferredAvaiable =
    tableDataQueryOptions.activeTab === "1" ||
    tableDataQueryOptions.activeTab === "3";
  const columns = getColumns();

  const onSuccessFirmMatch = () => {
    setFirmMatchModal({ ...firmMatchModal, isVisible: false });
    getTableData(true);
  };

  const onAdd = async (index, row) => {
    const newData = {
      amount: row.amount,
      amountString: row.amountString,
      bankId: row.bankId,
      bankLogo: row.bankLogo,
      bankName: row.bankName,
      currencyCode: row.currencyCode,
      chaResponsibilityCode: row.chaResponsibilityCode,
      bankResponsibilityCode: row.chaResponsibilityCode,
      centerOfResponsibilityCodeId: chaResponsbilityCodes.data.find(
        (item) => item.projectCode === row.chaResponsibilityCode
      )?.id,
      chequeNumber: row.chequeNumber,
      chequeNumbers: [],
      currency: row.currency,
      currencyId: row.currencyId,
      description: row.description,
      documentNumber: row.documentNumber,
      erpDescription: row.erpDescription,
      erpTransactionId: row.erpTransactionId,
      erpTransferStatus: row.erpTransferStatus,
      erpTransferStatusId: row.erpTransferStatusId,
      errorMessage: row.errorMessage,
      firmBranchNumber: row.firmBranchNumber,
      firmClassId: row.firmClassId,
      cardType: row.cardType,
      firmClassName: row.firmClassName,
      firmId: row.firmId,
      firmName: row.firmName,
      id: crypto.randomUUID(),
      isManualTransaction: row.isManualTransaction,
      projectCode: row.projectCode,
      referenceCode: row.referenceCode,
      tenantAccountErpCode: row.tenantAccountErpCode,
      tenantAccountId: row.tenantAccountId,
      tenantId: row.tenantId,
      transactionDate: row.transactionDate,
      transactionProcessType: row.transactionProcessType,
      transactionProcessTypeValue: row.transactionProcessTypeValue,
      transactionProjectTypeId: row.transactionProjectTypeId,
      transactionProjectTypeName: row.transactionProjectTypeName,
      transactionTypeId: row.transactionTypeId,
      isDuplicateTransaction: true,
      accountTransactionId: row.accountTransactionId,
      duplicatedTransactionNow: true,
      currencyExChangeRate: row.currencyExChangeRate,
      ibanOrAccountNumber: row.ibanOrAccountNumber,
      erpTransactionProjectTypeId: row.erpTransactionProjectTypeId,
      erpTransactionProjectTypeName: row.erpTransactionProjectTypeName,
      erpTransactionProjectTypeCode: row.erpTransactionProjectTypeCode,
      cosCenterId: row.cosCenterId,
      cosCenterName: row.cosCenterName,
      cosCenterCode: row.cosCenterCode,
      secondCosCenterId: row.secondCosCenterId,
      secondCosCenterName: row.secondCosCenterName,
      secondCosCenterCode: row.secondCosCenterCode,
      isCommission: row.isCommission,
      groupNumber: row.groupNumber,
      firmClassIsBankType: row.firmClassIsBankType,
    };
    const formRow = await form.validateFields();
    const newTableData = [...tableData.data];
    newTableData.splice(index + 1, 0, {
      ...newData,
      ...formRow,
    });
    setDuplicateTake(duplicateTake + 1);
    setTableData({
      data: newTableData,
      loading: false,
      total: totalDataCount + 1,
    });
  };

  const onDelete = (row) => {
    if (!row.duplicatedTransactionNow) {
      RequestHandler.delete(`/ErpDuplicateTransaction/${row.id}`).then(
        (response) => {
          if (!response.success) {
            return;
          }
        }
      );
    }
    setDuplicateTake(duplicateTake - 1);
    setTableData({
      data: tableData.data.filter((item) => item.id != row.id),
      loading: false,
      total: totalDataCount - 1,
    });
  };

  const edit = (record) => {
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record.id);
  };
  const cancel = () => {
    setEditingKey("");
  };
  const definitionCurrencies = [
    { id: 1, code: "TRY" },
    { id: 2, code: "USD" },
    { id: 3, code: "EUR" },
    { id: 4, code: "GBP" },
    { id: 7, code: "JPY" },
    { id: 9, code: "CHF" },
    { id: 10, code: "CNY" },
    { id: 11, code: "XAU" },
    { id: 12, code: "CAD" },
    { id: 16, code: "AUD" },
    { id: 17, code: "RUB" },
    { id: 18, code: "DKK" },
    { id: 20, code: "SEK" },
    { id: 21, code: "XAG" },
    { id: 22, code: "NOK" },
  ];
  const save = async (key) => {
    const row = await form.validateFields();
    const newData = [...tableData.data];
    const index = newData.findIndex((item) => key === item.id);
    if (index > -1) {
      const item = newData[index];
      var amount = new Intl.NumberFormat("tr-TR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(
        props.transactionProcessType === 1
          ? Math.abs(row.amount)
          : -1 * Math.abs(row.amount)
      );

      item.amount = Math.abs(row.amount);
      item.erpAmount = item.amount;
      if (item.currency == null || item.currency == undefined) {
        let curr = definitionCurrencies.find((i) => i.id === item.currencyId);
        if (curr) item.currency = curr.code;
      }
      item.amountString =
        amount +
        CurrencyHelper.GetCurrencySymbolHelper(
          item.currency.toLocaleLowerCase("tr-TR")
        );

      newData.splice(index, 1, {
        ...item,
        ...row,
      });
      setTableData({ data: newData, loading: false, total: tableData.total });
      setEditingKey("");
    } else {
      newData.push(row);
      setTableData({ data: newData, loading: false, total: tableData.total });
      setEditingKey("");
    }
  };

  const mergedColumns = getColumns().map((col) => {
    if (!col.editable) {
      return col;
    }
    if (col.editable && col.dataIndex == "amount") {
      return {
        ...col,
        onCell: (record) => ({
          record,
          inputType: "number",
          dataIndex: "amount",
          title: col.title,
          editing: isEditing(record),
        }),
      };
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const onChangeSelectType = (e) => {
    setSelectType(e);
  };
  return (
    <>
      <Row>
        <Col xs={24} md={8} lg={16} xl={isBigScreen ? 15 : 14}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> {options.pageTitle}
          </p>
        </Col>

        {columnSettings?.isUseLogoCheck && (
          <Col
            hidden={
              tableDataQueryOptions.activeTab === "-1" ||
              tableDataQueryOptions.activeTab === "1" ||
              tableDataQueryOptions.activeTab === "2"
            }
            xs={24}
            md={8}
            lg={4}
            xl={2}
            style={{ textAlign: "right" }}
          >
            <Popconfirm
              title={
                "Seçili hareketler için mükerrer kontrol yapmak istiyor musunuz?"
              }
              okText="Evet"
              cancelText="Hayır"
              placement="bottom"
              disabled={selectedRowKeys.length < 1}
              onConfirm={onConfirmDoubleCheckForLogo}
              style={{ color: "seagreen" }}
            >
              <Button
                type="primary"
                disabled={selectedRowKeys.length < 1}
                style={{ marginBottom: 0 }}
              >
                <SendOutlined /> Mükerrer Kontrol
              </Button>
            </Popconfirm>
          </Col>
        )}

        <Col
          hidden={tableDataQueryOptions.activeTab !== "1"}
          xs={24}
          md={8}
          lg={6}
          xl={6}
          style={{ textAlign: "right" }}
        >
          <Popconfirm
            title={
              "Seçili hareketleri kontrol edildi olarak işaretlemek istiyor musunuz?"
            }
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={onConfirmIsCheckedExport}
            style={{ color: "seagreen" }}
          >
            <Button
              type="primary"
              disabled={selectedRowKeys.length < 1}
              style={{ marginBottom: 0 }}
            >
              <SendOutlined /> Kontrol Edildi
            </Button>
          </Popconfirm>
        </Col>
        {onlyFullOnes && (
          <Col
            xs={24}
            md={8}
            lg={4}
            style={{ textAlign: "right", paddingLeft: "0px", marginTop: "8px" }}
            hidden={tableDataQueryOptions.activeTab != "0"}
          >
            Dolu Olanları Seç
            <Switch
              defaultChecked
              style={{ margin: "0 10px" }}
              onChange={onChangeSelectType}
            />
            Tümünü Seç
          </Col>
        )}
        <Col
          xs={24}
          md={8}
          lg={tableDataQueryOptions.activeTab === "1" ? 2 : 4}
          xl={2}
          style={{ textAlign: "right", paddingLeft: "0px" }}
        >
          <Popconfirm
            title={
              tableDataQueryOptions.activeTab === "0" ||
              tableDataQueryOptions.activeTab === "3"
                ? "Aktarıldı olarak işaretlensin mi?"
                : "Aktarılmadı olarak işaretlensin mi?"
            }
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={!allowMarkAsTransfered || selectedRowKeys.length < 1}
            onConfirm={
              tableDataQueryOptions.activeTab === "0" ||
              tableDataQueryOptions.activeTab === "3"
                ? onConfirmSuccessfulExport
                : onConfirmNotTransferredExport
            }
            style={{ color: "seagreen" }}
          >
            {(tableDataQueryOptions.activeTab === "0" ||
              tableDataQueryOptions.activeTab === "1" ||
              tableDataQueryOptions.activeTab === "3") && (
              <Tooltip
                title={
                  !allowMarkAsTransfered
                    ? "Yetkiniz yoktur lütfen yöneticinizle görüşünüz"
                    : ""
                }
              >
                <Button
                  type="primary"
                  disabled={
                    !allowMarkAsTransfered || selectedRowKeys.length < 1
                  }
                  style={{ marginBottom: 0 }}
                >
                  <SendOutlined />{" "}
                  {(tableDataQueryOptions.activeTab === "0" ||
                    tableDataQueryOptions.activeTab === "3") &&
                    "Aktarıldı Yap"}
                  {tableDataQueryOptions.activeTab === "1" && "Aktarılmadı Yap"}
                </Button>
              </Tooltip>
            )}
          </Popconfirm>
        </Col>
        <Col
          xs={24}
          md={8}
          lg={4}
          xl={2}
          style={{ textAlign: "right" }}
          hidden={tableDataQueryOptions.activeTab === "1"}
        >
          <Popconfirm
            title={confirmErpTitle}
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={onConfirmExport}
          >
            {isExportAvailable && (
              <Button
                type="primary"
                disabled={selectedRowKeys.length < 1}
                style={{ marginBottom: 0 }}
                onClick={() => TransactionDateControl()}
              >
                <SendOutlined /> Erp'ye Aktar
              </Button>
            )}
          </Popconfirm>

          <Popconfirm
            visible={virmanPopConfirmVisible}
            title="Seçilen hareketler arasında virman hareketler bulunmaktadır.
             Bu hareketlerin Erp'ye aktarılmasını istiyor musunuz?"
            okText="Evet Aktar"
            cancelText="Hayır Aktarıldı Yap"
            placement="bottom"
            onConfirm={onConfirmVirmanOkExport}
            onCancel={onConfirmVirmanSetSuccessfulExport}
          ></Popconfirm>
        </Col>
        <Col
          xs={24}
          md={12}
          lg={2}
          xl={isBigScreen ? 1 : 2}
          style={{ textAlign: "center" }}
        >
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                paddingLeft: !isBigScreen ? 20 : 0,
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>
      <ErpExportTransactionTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      {/*<ErpReportSummary data={summaryData} loading={loadingSummary} />*/}

      <Tabs
        defaultActiveKey={tableDataQueryOptions.activeTab}
        onChange={onTabChange}
      >
        <Tabs.TabPane tab="Tümü" key="-1" />
        <Tabs.TabPane tab="Aktarılmadı" key="0" />
        <Tabs.TabPane tab="Başarılı" key="1" />
        <Tabs.TabPane tab="Aktarılıyor" key="2" />
        <Tabs.TabPane tab="Başarısız" key="3" />
      </Tabs>

      <Row id="tableArea">
        <Col span={24}>
          <Form form={form} component={false}>
            <Table
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              rowSelection={
                isExportAvailable
                  ? {
                      selectedRowKeys: selectedRowKeys,
                      onSelect: onTableSelect,
                      onSelectAll: onTableSelectAll,
                    }
                  : tableDataQueryOptions.activeTab === "1"
                  ? {
                      selectedRowKeys: selectedRowKeys,
                      onSelect: onTableSelect,
                      onSelectAll: onTableSelectAll,
                    }
                  : undefined
              }
              columns={
                columnSettings?.isHasDuplicateTransaction
                  ? mergedColumns
                  : columns
              }
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Veri Yok"
                  />
                ),
              }}
              style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
              rowKey="id"
              filterable={true}
              sortable={true}
              pageable={true}
              onChange={paging}
              pagination={{
                defaultPageSize: columnSettings?.isHasDuplicateTransaction
                  ? duplicateTake
                  : tableDataQueryOptions.take,
                pageSizeOptions: ["15", "25", "50", "100", "200", "300"],
                total: tableData.total,
                current: tableDataQueryOptions.current,
                pageSize: columnSettings?.isHasDuplicateTransaction
                  ? duplicateTake
                  : tableDataQueryOptions.take,
              }}
              dataSource={tableData.data}
              loading={tableData.loading}
              size="small"
            />
          </Form>
        </Col>
      </Row>

      <Modal
        centered
        title={
          firmMatchModal.isUpdate
            ? "Kayıtlı Cari Güncelle"
            : "Kayıtlı Cari Eşleştir"
        }
        visible={firmMatchModal.isVisible}
        onCancel={() =>
          setFirmMatchModal({ ...firmMatchModal, isVisible: false })
        }
        footer={null}
      >
        <FirmTransactionMatchForm
          onSuccess={onSuccessFirmMatch}
          isUpdate={firmMatchModal.isUpdate}
          data={firmMatchFormData}
        />
      </Modal>

      <Modal
        title={"Virman Hesap Hareketleri"}
        visible={visibleVirmanMatchedTransactions}
        centered={true}
        keyboard={true}
        onOk={() => {
          onConfirmVirmanOkExport();
          setVisibleVirmanMatchedTransactions(false);
        }}
        onCancel={() => {
          setVisibleVirmanMatchedTransactions(false);
        }}
        width={1000}
        destroyOnClose={true}
      >
        <ErpVirmanMatchedTransaction
          Data={virmanTransactions}
          SelectedVirmanTransactions={(selectedVirmanTransactions) =>
            setSelectedVirmanTransactions(selectedVirmanTransactions)
          }
          transactionProcessType={props.transactionProcessType}
        />
      </Modal>

      <Modal
        visible={multipleRuleAddModalVisible}
        centered={true}
        keyboard={true}
        onCancel={() => {
          setMultipleRuleAddModalVisible(false);
        }}
        width={1000}
        destroyOnClose={true}
        okButtonProps={{ hidden: true }}
        closable={false}
        maskClosable={false}
        footer={[
          <Popconfirm
            title="Eklenmeyen kurallar var. Kural Ekleme işlemini iptal etmek istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => setMultipleRuleAddModalVisible(false)}
          >
            <Button key="back">İptal</Button>
          </Popconfirm>,
        ]}
      >
        <MultipleAccountTransactionRuleList
          data={multipleRuleAddData}
          onSuccess={() => {
            setMultipleRuleAddModalVisible(false);
          }}
        />
      </Modal>

      <Modal
        title={"Mükerrer Hesap Hareketleri"}
        visible={visibleLogoCheckTransactionModal}
        centered={true}
        keyboard={true}
        onOk={() => {
          getTableData();
          setVisibleLogoCheckTransactionModal(false);
        }}
        onCancel={() => {
          getTableData();
          setVisibleLogoCheckTransactionModal(false);
        }}
        width={1200}
        destroyOnClose={true}
        okButtonProps={{ hidden: true }}
        cancelButtonProps={{ hidden: true }}
      >
        <ErpLogoDoubleCheckTransaction Data={logoCheckData} />
      </Modal>
    </>
  );
};
export default ErpExportTransaction;
